import { writable, derived } from 'svelte/store';
export const user = writable(null);
export const sid = writable("");
export const isUserLoggedIn = derived(user, $u => $u != null);
export const isUserRoleADM = derived(user, $u => ($u === null || $u === void 0 ? void 0 : $u.roles) && $u.roles.find(x => x === 'ADM') !== undefined);
export const isUserRoleWOR = derived(user, $u => ($u === null || $u === void 0 ? void 0 : $u.roles) && $u.roles.find(x => x === 'WOR') !== undefined);
export const isUserRoleVET = derived(user, $u => ($u === null || $u === void 0 ? void 0 : $u.roles) && $u.roles.find(x => x === 'VET') !== undefined);
export const isUserRoleQCC = derived(user, $u => ($u === null || $u === void 0 ? void 0 : $u.roles) && $u.roles.find(x => x === 'QCC') !== undefined);
